import React from 'react';
import "./Mail.css";
import { useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Helmet } from "react-helmet-async";

function Mail() {
  // Generate a list of years dynamically (e.g., from 2000 to current year + 5 for flexibility)
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 20 }, (_, i) => currentYear - i); // Last 30 years

  const [loading, setLoading] = useState(false);

  const [errors, setErrors] = useState({
    email: "",
    phone: "",
  });


  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const form = e.target;

    const email = form.email.value.trim();
    const phone = form.phone.value.trim();

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^[6-9]\d{9}$/;

    const newErrors = {};

    if (!emailRegex.test(email)) {
      newErrors.email = "Enter a valid email address";
    }

    if (!phoneRegex.test(phone)) {
      newErrors.phone = "Enter a valid 10 digit mobile number";
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      setLoading(false);
      return;
    }

    setErrors({});

    try {
      const data = new FormData(form);

      const response = await fetch(
        `https://formspree.io/f/${process.env.REACT_APP_FORMSPREE_TRAINING_FORM_ID}`,
        {
          method: "POST",
          body: data,
          headers: {
            Accept: "application/json",
          },
        }
      );

      if (response.ok) {
        toast.success("Message sent successfully! We will contact you soon.");
        form.reset();
      } else {
        toast.error("Failed to send message. Please try again.");
      }
    } catch (error) {
      toast.error("Something went wrong. Please try again.");
    }

    setLoading(false);
  };
  return (

    <>
      <Helmet>

        {/* <!-- Canonical URL --> */}
        <link rel="canonical" href="https://kitkatsoftwaretechnologies.com/mail" />
        {/* <!-- Hreflang Tags --> */}
        <link rel="alternate" hrefLang="en-US" href="https://kitkatsoftwaretechnologies.com/mail" />
        <link rel="alternate" hrefLang="en-GB" href="https://kitkatsoftwaretechnologies.com/mail" />
        <link rel="alternate" hrefLang="en-MY" href="https://kitkatsoftwaretechnologies.com/mail" />
        <link rel="alternate" hrefLang="en-SG" href="https://kitkatsoftwaretechnologies.com/mail" />
        <link rel="alternate" hrefLang="en-AE" href="https://kitkatsoftwaretechnologies.com/mail" />
        <link rel="alternate" hrefLang="x-default" href="https://kitkatsoftwaretechnologies.com/mail" />
      </Helmet>


      <div className="mail-container">
        <div className="mail-card">
          <h1 className="mail-title">Contact Us</h1>
          <p className="mail-subtitle">We'd love to hear from you! Send us a message and we'll get back to you shortly.</p>

          <form className="mail-form" onSubmit={handleSubmit}>

            <div className="form-group">
              <label htmlFor="name" className="form-label">Name</label>
              <input type="text" id="name" name="name" className="form-input" placeholder="Enter your name" maxLength="20" required
              />
            </div>

            <div className="form-group">
              <label htmlFor="email" className="form-label">Email</label>
              <input type="email" id="email" name="email" className="form-input" placeholder="Enter your email" required
              />
              {errors.email && <span className="form-error">{errors.email}</span>}
            </div>

            <div className="form-group">
              <label htmlFor="phone" className="form-label">Mobile Number</label>
              <input type="tel" id="phone" name="phone" className="form-input" placeholder="Enter your mobile number" maxLength="10" required
              />
              {errors.phone && <span className="form-error">{errors.phone}</span>}
            </div>

            <div className="form-group">
              <label htmlFor="degree" className="form-label">Degree</label>
              <input type="text" id="degree" name="degree" className="form-input" placeholder="Enter your degree" required
              />
            </div>

            <div className="form-group">
              <label htmlFor="passout-year" className="form-label">Pass Out Year</label>
              <select id="passout-year" name="passout-year" className="form-input" required>
                <option value="">Select Year</option>
                {years.map(year => (
                  <option key={year} value={year}>{year}</option>
                ))}
              </select>
            </div>

            <input type="hidden" name="_subject" value="New enquiry from website training form" />

            <div className="form-group">
              <button type="submit" className="submit-button" disabled={loading}>
                {loading ? 'Sending...' : 'Send Message'}
              </button>
            </div>
          </form>
        </div>
        <ToastContainer
          position="top-right"
          autoClose={4000}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          pauseOnHover
          theme="colored"
        />
      </div></>
  );
}

export default Mail;

